import config from './config.json';
import { EnvironmentObject, ConfigObject } from './env.models';

export const environment: EnvironmentObject = {
  production: true,
  serverUrl: (<ConfigObject>config).stagingServerUrl,
  pollerTime: 60000,
  name: 'Staging',
  enable_sentry: true,
  isAuctionEnabled: (<ConfigObject>config).isAuctionEnabled

};

